<!-- vue3 加密标签组件 脱敏 -->
<template>
  <div class="encryption_style" @click="decrypt(encKey)">
    {{ encData }}
  </div>
</template>
<script setup>
  import h_i18n from '@/utils/Internationalization';
  import { getCurrentInstance } from "vue";
  import { useRoute } from "vue-router";
  import encryptionApi from './api.js'
  const route = useRoute();
  const { proxy, ctx } = getCurrentInstance()
  const props = defineProps({
    encData: {
      type: String,
      default: ''
    },
    encKey:{
      type: String,
      default: ''
    },
    name:{
      type: String,
      default: ''
    },
    supplyData:{
      type:Object,
      default:{}
    }
  })
  // 解密日志 vmiService/basicData/saveDecryptLog
  const saveDecLog = () =>{
    let data = {
      operatorId: route.query.supplyCode,
      operatorName: route.query.trueName,
      operateDate:proxy.time(new Date(),6),
      operateObjectId: props.supplyData.supplyCode || route.query.supplyCode, 
      operateObjectName: props.supplyData.supplyName || route.query.trueName,
      business: props.name,
      createdBy: route.query.trueName,
      createdTime: proxy.time(new Date(),6),
      fixConfig: true,
    }
    let promise = encryptionApi.saveDecLog(proxy,data)
    promise.then(res=>{

    }).catch(err=>{

    })
  }
  // 解密方法 /base/decrypt
  const decrypt = (encKey) => {
    if (encKey) {
      let promise = encryptionApi.decrypt(proxy,JSON.stringify([encKey]))
      promise.then(res=>{
        if(res.data.success == true && res.data.data && res.data.data.length == 1){
          // 解密成功
          proxy.success({title:h_i18n('5ad7f5a8b22e331abe82a6be5f4d6e01'),message:res.data.data[0],confirmButtonText:h_i18n('38cf16f2204ffab8a6e0187070558721')})
          saveDecLog()
        }else{
          // 解密失败
          proxy.warning(res.data.errMessage)
        }
      })
    } else {
      // 无数据
    }
  }
</script>
<style lang="scss">
.encryption_style{
  cursor: pointer;
}
</style>